module.exports = __webpack_public_path__ + "img/flower_leaf_19.31351c06.png";